import { useState } from "react";
import { useGetCocktailsQuery } from "../../../../services/cocktail";
import { ModalButton } from "../../../Controls/Buttons/ModalButton";
import { StyledIonCheckbox } from "../../../Controls/Inputs/CheckboxSelect";
import Input from "../../../Controls/Inputs/Input";
import Loader from "../../../Controls/Loader/Loader";
import { QuizButtonsWrapper } from "../../../Quizzes/Quiz/QuizButtonsWrapper";
import { NotFoundText } from "../CocktailsFiltersModal";
import { Magnifier } from "../../../Icons/Magnifier";
import { useGetTastesQuery } from "../../../../services/taste";
import { useCocktailsContext } from "../../../../hooks/useAppContext";

interface GlassTypeProps {
    choicesCocktails: number[];
    setOpenModal: (isOpen: boolean) => void;
}

const GlassType = (props: GlassTypeProps) => {
    const { setOpenModal, choicesCocktails } = props;
    const [searchTasteValue, setSearchTasteValue] = useState("");
    const [choiceCocktails, setChoiceCocktails] =
        useState<number[]>(choicesCocktails);
    const { dispatch, state } = useCocktailsContext();

    const {
        data: tasteData,
        isFetching,
        isSuccess,
    } = useGetTastesQuery({
        search: searchTasteValue,
        per_page: 50,
    });

    const { data: cocktailsData, isFetching: fetchingData } =
        useGetCocktailsQuery({
            search: state.search,
            taste_ids: choiceCocktails.length > 0 ? choiceCocktails : undefined,
            per_page: 50,
        });

    const handleShowResult = () => {
        dispatch({
            type: "FILTER_BY_TASTE",
            payload: choiceCocktails,
        });
        setOpenModal(false);
    };

    const handleCheckCategory = (id: number) => {
        setChoiceCocktails((choiceCocktails) => {
            if (choiceCocktails.includes(id)) {
                return choiceCocktails.filter((cocktail) => cocktail !== id);
            } else {
                return [...choiceCocktails, id];
            }
        });
    };

    return (
        <>
            <Input
                icon={<Magnifier height={25} />}
                type="text"
                value={searchTasteValue}
                placeholder="Znajdź smak"
                onChange={(value) => setSearchTasteValue(value)}
                marginBottom={16}
            />
            {isFetching ? (
                <Loader fullScreen />
            ) : isSuccess ? (
                tasteData?.data.map((taste) => (
                    <StyledIonCheckbox
                        key={taste.id}
                        onIonChange={() => handleCheckCategory(taste.id)}
                        labelPlacement="end"
                        checked={choiceCocktails.some(
                            (item) => item === taste.id
                        )}
                    >
                        {taste.name}
                    </StyledIonCheckbox>
                ))
            ) : null}
            {tasteData?.data.length === 0 && (
                <NotFoundText>{`Nie znaleziono smaku o nazwie ${searchTasteValue}`}</NotFoundText>
            )}

            <QuizButtonsWrapper>
                <ModalButton
                    color={"white"}
                    onClick={() => setChoiceCocktails([])}
                >
                    wyczyść
                </ModalButton>
                <ModalButton
                    disabled={fetchingData || !cocktailsData?.meta.total}
                    onClick={handleShowResult}
                >
                    {fetchingData ? (
                        <Loader />
                    ) : (
                        `wyświetl (${cocktailsData?.meta.total ?? "0"})`
                    )}
                </ModalButton>
            </QuizButtonsWrapper>
        </>
    );
};

export default GlassType;
